let scrollpos = window.scrollY
const header = document.querySelector('header')
//const header_height = header.offsetHeight
const blue_section = document.querySelector('.blue-section');

window.addEventListener('scroll', function() { 
    scrollpos = window.scrollY;

    if (scrollpos >= 20) { 
        header.classList.add('scrolled')
    } else { 
        header.classList.remove('scrolled')
    }

    if(blue_section){
        if((blue_section.offsetTop - 300 <= scrollpos) && (blue_section.offsetTop + blue_section.clientHeight - 300 >= scrollpos)) {
            blue_section.classList.add('show-blue')
        } else {
            blue_section.classList.remove('show-blue')
        }
    }
    //console.log(scrollpos)
})

function getTargetParent(elem, targetClass) {
    let currElem = elem;
    while(
        currElem
        && !currElem.classList.contains(targetClass)
    ) {
    	currElem = currElem.parentNode;
    }
    return currElem;
}

const intro_content = document.querySelector('.top-content-home')

if(intro_content){
    document.getElementsByClassName('top-content-home')[0].classList.add('appear')
}

const intro_default = document.querySelector('.foundation-default-intro')

if(intro_default){
    document.getElementsByClassName('foundation-default-intro')[0].classList.add('appear')
}

const intro_header = document.querySelector('.default-hero__title')

if(intro_header){
    document.getElementsByClassName('default-hero__title')[0].classList.add('appear')
}


const animateHTML = function () {
    let elems,
        elemsShow,
        windowHeight;
    let init = function () {
        elems = document.getElementsByClassName('hide-object');
        elemsShow = document.getElementsByClassName('show-object');
        windowHeight = window.innerHeight;
        addEventHandlers();
    }; 
    let addEventHandlers = function () {
        window.addEventListener('scroll', checkPosition);
        window.addEventListener('resize', init);
    };
    let checkPosition = function () {
        for (let i = 0; i < elems.length; i++) {
            let posFromTop = elems[i].getBoundingClientRect().top;
            if (posFromTop - windowHeight <= 0) {
                elems[i].className = elems[i].className.replace('hide-object', 'show-object')
            }
        } 
        for (let i = 0; i < elemsShow.length; i++) {
            let posFromTop = elemsShow[i].getBoundingClientRect().top;
            if (posFromTop - windowHeight >= 0) {
                elemsShow[i].className = elemsShow[i].className.replace('show-object', 'hide-object')
            } 
        } 
    };
    return {
        init: init 
    }
};
animateHTML().init();

function addFocusListener(elem, targetClass) {
    let targetParent = getTargetParent(elem, targetClass);
    if(targetParent) {
            elem.addEventListener('focus', function() {
            targetParent.classList.add('focus');
        });
        elem.addEventListener('blur', function() {
            targetParent.classList.remove('focus');
        });
    }
}

let inputs = document.getElementsByClassName('ctct-form-element');
setTimeout(function(){
    for(var i = 0; i < inputs.length; i++) {
        addFocusListener(inputs[i], 'ctct-form-field');
    }
}, 2500);

//mobile
( function() {
	var container, button, menu, links, i, len;

	container = document.getElementById( 'header__nav' );
	if ( ! container ) {
		return;
	}

	button = container.getElementsByTagName( 'button' )[0];
	if ( 'undefined' === typeof button ) {
		return; 
	}

	menu = container.getElementsByTagName( 'ul' )[0];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
		menu.className += ' nav-menu';
	}

	button.onclick = function() {
		if ( -1 !== container.className.indexOf( 'toggled' ) ) {
			container.className = container.className.replace( ' toggled', '' );
			button.setAttribute( 'aria-expanded', 'false' );
			button.innerHTML = "Menu";
		} else {
			container.className += ' toggled';
			button.setAttribute( 'aria-expanded', 'true' );
			button.innerHTML = "Close";
		}
	};

	// Close small menu when user clicks outside
	document.addEventListener( 'click', function( event ) {
		var isClickInside = container.contains( event.target );

		if ( ! isClickInside ) {
			container.className = container.className.replace( ' toggled', '' );
			button.setAttribute( 'aria-expanded', 'false' );
		}
	} );

	// Get all the link elements within the menu.
	links = menu.getElementsByTagName( 'a' );

	// Each time a menu link is focused or blurred, toggle focus.
	for ( i = 0, len = links.length; i < len; i++ ) {
		links[i].addEventListener( 'focus', toggleFocus, true );
		links[i].addEventListener( 'blur', toggleFocus, true );
	}

    /**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		var self = this;

		// Move up through the ancestors of the current link until we hit .nav-menu.
		while ( -1 === self.className.indexOf( 'nav-menu' ) ) {
			// On li elements toggle the class .focus.
			if ( 'li' === self.tagName.toLowerCase() ) {
				if ( -1 !== self.className.indexOf( 'focus' ) ) {
					self.className = self.className.replace( ' focus', '' );
				} else {
					self.className += ' focus';
				}
			}

			self = self.parentElement;
		}
	}
	
}() );
//end mobile

jQuery(function($) {
    $('.slick-rotator').slick({
        accessibility: false
    });
});